import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Kazi Shahriar Sanjid</span>
            from <span className="purple">Dhaka, Bangladesh.</span>
            <br />
            I am a <span className="purple">PhD Applicant</span> focused on Algorithms, AI & Systems for Computational Biology.
            <br />
            Currently, I serve as a <span className="purple">Research Assistant</span> at North South University (April 2023 - Present) and an <span className="purple">AI Research Engineer (Part Time)</span> at Diagnotech-Ai (July 2023 - Present).
            <br />
            I am pursuing a <span className="purple">Bachelor of Science in Computer Science and Engineering</span> at North South University with a GPA of 3.59/4.0 (Expected graduation: December 2025).
            <br />
            <br />
            My research focuses on developing novel algorithms integrating State Space Models (Mamba) with hierarchical networks for biomedical segmentation, achieving state-of-the-art accuracy with reduced computational complexity. I have contributed to <span className="purple">5+ publications</span> including 2 Q1 journals, 1 conference, and 2 preprints.
            <br />
            <br />
            Apart from research, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Writing Tech Blogs
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">Kazi Shahriar Sanjid</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
